import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TableCellData } from '@/utils/measurements/table-data-generator';
import { RootState } from '@/store/rootReducer';

type PatientMeasurementContextState = {
  patientId?: number;
  highlightId?: string;
  calculatedMeasurementData?: TableCellData[];
  isHideAlarm?: boolean;
  isExpandPinnedList?: boolean;
  isMoreThanFourPinnedList?: boolean;
  isMoreThanEightPinnedList?: boolean;
};

const slice = createSlice({
  name: 'patient-measurement-context',
  initialState: {
    highlightId: '',
    calculatedMeasurementData: [],
  } as PatientMeasurementContextState,
  reducers: {
    setHighlightId: (
      state,
      {
        payload: { highlightId },
      }: PayloadAction<PatientMeasurementContextState>
    ) => {
      state.highlightId = highlightId;
    },
    setPatientId: (
      state,
      { payload: { patientId } }: PayloadAction<PatientMeasurementContextState>
    ) => {
      state.patientId = patientId;
    },
    setHideAlarm: (
      state,
      {
        payload: { isHideAlarm },
      }: PayloadAction<PatientMeasurementContextState>
    ) => {
      state.isHideAlarm = isHideAlarm;
    },
    setCalculatedMeasurementData: (
      state,
      { payload: { calculatedMeasurementData } }
    ) => {
      state.calculatedMeasurementData = calculatedMeasurementData;
    },
    togglePinnedListExpand: (state, { payload: { isExpandPinnedList } }) => {
      state.isExpandPinnedList = isExpandPinnedList;
    },
    checkMoreThanFourPinnedList: (
      state,
      { payload: { isMoreThanFourPinnedList } }
    ) => {
      state.isMoreThanFourPinnedList = isMoreThanFourPinnedList;
    },
    checkMoreThanEightPinnedList: (
      state,
      { payload: { isMoreThanEightPinnedList } }
    ) => {
      state.isMoreThanEightPinnedList = isMoreThanEightPinnedList;
    },
  },
});

export const {
  setHighlightId,
  setHideAlarm,
  setCalculatedMeasurementData,
  setPatientId,
  togglePinnedListExpand,
  checkMoreThanFourPinnedList,
  checkMoreThanEightPinnedList,
} = slice.actions;

export default slice.reducer;

export const selectPatientMeasurementContext = (state: RootState) =>
  state.patientMeasurementContext;

export const expandPinnedList = (state: RootState) =>
  state.patientMeasurementContext.isExpandPinnedList;
export const moreThanFourPinnedList = (state: RootState) =>
  state.patientMeasurementContext.isMoreThanFourPinnedList;
export const moreThanEightPinnedList = (state: RootState) =>
  state.patientMeasurementContext.isMoreThanEightPinnedList;

export const selectPatientIsHideAlarm = (state: RootState) =>
  state.patientMeasurementContext.isHideAlarm;
